/**
 * MeasureKind enum for the prevention-list application
 * Represents different types of prevention measures
 */
export enum MeasureKind {
    Single = 'Einmalig',
    Continuous = 'Fortlaufend',
    Modular = 'Modular aufgebaut',
}

/**
 * Determines the most likely measure kind enum value based on the input string
 *
 * @param measureKindString The measure kind string from the API
 * @returns The most likely MeasureKind enum value
 */
export function determineMeasureKindType(measureKindString: string): MeasureKind {
    // Map common measure kind strings to our enum values
    if (measureKindString.includes('SINGLE')) {
        return MeasureKind.Single;
    } else if (measureKindString.includes('CONTINUOUS')) {
        return MeasureKind.Continuous;
    } else if (measureKindString.includes('MODULAR')) {
        return MeasureKind.Modular;
    }
    return MeasureKind.Single;
}
